import { useNavigate } from "react-router-dom";
import { ChevronLeft, BookOpen, ArrowRight } from "lucide-react";

const departments = [
  { id: "1", title: "자존감학과", description: "자기 가치 점검과 상처 회복", color: "#0D5F5E", label: "MIND", image: "https://images.unsplash.com/photo-1635607596286-cf52df4b912d?w=400&h=300&fit=crop" },
  { id: "2", title: "소통기술학과", description: "호감형 대화법과 카톡 훈련", color: "#8B4541", label: "SKILL", image: "https://images.unsplash.com/photo-1604881991405-b273c7a4386a?w=400&h=300&fit=crop" },
  { id: "3", title: "여성학과", description: "맞춤 연애 팁과 매력 발산", color: "#7B8DB8", label: "FOR HER", image: "https://images.pexels.com/photos/10265201/pexels-photo-10265201.jpeg?auto=compress&cs=tinysrgb&w=400&h=300&fit=crop" },
  { id: "4", title: "남성학과", description: "연애 팁과 매너, 리더십", color: "#2C4A5E", label: "FOR HIM", image: "https://images.unsplash.com/photo-1650036517860-620ab8a9af0f?w=400&h=300&fit=crop" },
  { id: "5", title: "연애학과", description: "설렘부터 고백까지 A to Z", color: "#C4956A", label: "LOVE", image: "https://images.unsplash.com/photo-1649389457678-11c7dd5bc85a?w=400&h=300&fit=crop" },
  { id: "6", title: "매력학과", description: "외면·내면 매력 업그레이드", color: "#6B4C6E", label: "CHARM", image: "https://images.unsplash.com/photo-1762342695113-0ab0918b6f3b?w=400&h=300&fit=crop" },
  { id: "7", title: "사랑학과", description: "진정한 사랑의 기술", color: "#3A6B5E", label: "HEART", image: "https://images.unsplash.com/photo-1695645233313-3b1c7b825973?w=400&h=300&fit=crop" },
  { id: "8", title: "갈등학과", description: "관계 회복과 소통의 기술", color: "#8B6B4A", label: "HEAL", image: "https://images.unsplash.com/photo-1575752002196-782497f1c0c4?w=400&h=300&fit=crop" },
  { id: "9", title: "이혼 치유학과", description: "아픔을 딛고 새 출발", color: "#5E4A6B", label: "RESTART", image: "https://images.unsplash.com/photo-1662466818280-5f5155cbf559?w=400&h=300&fit=crop" },
  { id: "10", title: "사별 회복학과", description: "상실감 극복과 재시작", color: "#4A6B7B", label: "RECOVER", image: "https://images.unsplash.com/photo-1562263055-38a8df587f69?w=400&h=300&fit=crop" },
  { id: "11", title: "결혼학과", description: "행복한 결혼을 위한 준비", color: "#6B5E4A", label: "MARRIAGE", image: "https://images.unsplash.com/photo-1769374072073-bc358149ecee?w=400&h=300&fit=crop" },
  { id: "12", title: "중년성학과", description: "친밀감과 깊은 교감", color: "#8B7B8B", label: "INTIMACY", image: "https://images.unsplash.com/photo-1684613876886-d194b8feb903?w=400&h=300&fit=crop" },
];

export default function LoveAcademyPage() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-stone-50 pt-20">
      {/* Hero Section */}
      <section className="relative overflow-hidden">
        <div className="relative flex flex-col md:flex-row h-[400px] md:h-[450px] overflow-hidden" style={{ backgroundColor: '#F3ECEC' }}>
          {/* Left - Text */}
          <div className="p-10 md:p-14 flex flex-col justify-center md:w-[40%] relative z-10">
            <button
              onClick={() => navigate("/")}
              className="flex items-center gap-2 text-stone-400 hover:text-stone-700 transition-colors mb-8 w-fit"
            >
              <ChevronLeft className="w-4 h-4" />
              <span className="text-sm">홈으로</span>
            </button>

            <span className="text-stone-400 text-xs tracking-widest uppercase mb-3 block">Curriculum</span>
            
            <div className="flex items-center gap-4 mb-6">
              <div className="w-12 h-12 rounded-2xl flex items-center justify-center" style={{ backgroundColor: 'rgba(237,231,237,0.5)' }}>
                <BookOpen className="w-6 h-6 text-stone-600" />
              </div>
              <h1 className="font-sans text-3xl md:text-4xl font-[720] text-stone-800">연애사관학교</h1>
            </div>

            <p className="text-stone-500 text-sm leading-relaxed">
              연애는 막연한 예감이 아닌, 마음을 읽는 정교한 배움에서 시작됩니다.<br />
              시행착오의 시간을 줄이고, 당신의 사랑이 머물러야 할 확실한 이정표를 제시합니다.<br /><br />
              나를 투영하고 상대를 깊이 수용하는 관계의 미학—<br />
              찰나의 설렘을 넘어, 시간이 흐를수록 깊어지는 사랑의 기술을 전합니다.
            </p>
          </div>

          {/* Right - Image with seamless blend */}
          <div className="md:w-[60%] relative h-full">
            <img 
              src="https://customer-assets.emergentagent.com/job_9277ad9a-6109-40e4-9d7a-82032fc09839/artifacts/3frabvml_ChatGPT%20Image%20Apr%207%2C%202026%2C%2009_34_23%20AM.png"
              alt="연애사관학교"
              className="w-full h-full object-cover object-[center_30%]"
            />
            {/* Gradient to blend left edge into background */}
            <div 
              className="absolute inset-y-0 left-0 w-24"
              style={{ background: 'linear-gradient(to right, #F3ECEC, transparent)' }}
            />
          </div>
        </div>
      </section>

      {/* Departments Grid */}
      <section className="py-12 px-6">
        <div className="max-w-6xl mx-auto">
          <h2 className="text-xl font-[720] text-stone-800 mb-8">전체 학과 ({departments.length}개)</h2>
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
            {departments.map((dept) => (
              <button
                key={dept.id}
                onClick={() => navigate(`/curriculum/${dept.id}`)}
                className="group text-left"
                data-testid={`dept-${dept.id}`}
              >
                <div 
                  className="rounded-2xl overflow-hidden flex flex-col h-[320px] md:h-[360px] transition-all group-hover:scale-[1.02] group-hover:shadow-xl"
                  style={{ backgroundColor: dept.color }}
                >
                  {/* Top - Text area */}
                  <div className="p-5 flex-shrink-0">
                    <span className="text-white/40 text-base md:text-lg tracking-[0.15em] uppercase font-semibold block">{dept.label}</span>
                    <h3 className="text-white font-bold text-lg md:text-xl mt-2 leading-tight">{dept.title}</h3>
                    <p className="text-white/60 text-xs mt-2 leading-relaxed">{dept.description}</p>
                  </div>
                  {/* Bottom - Image area with arrow */}
                  <div className="flex-1 relative overflow-hidden">
                    <img 
                      src={dept.image} 
                      alt={dept.title}
                      className="w-full h-full object-cover opacity-60 group-hover:opacity-80 transition-opacity"
                    />
                    <div className="absolute bottom-4 right-4 w-9 h-9 rounded-full border border-white/50 flex items-center justify-center bg-black/20 group-hover:bg-white/20 transition-colors">
                      <ArrowRight className="w-4 h-4 text-white" />
                    </div>
                  </div>
                </div>
              </button>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
